const countdown = document.getElementById("countdown");

if (countdown) {
    const countDownDate = new Date("May 30, 2025 09:00:00").getTime();

    // Update the count down every 1 second
    const x = setInterval(function () {

        // Get today's date and time
        const now = new Date().getTime();

        // Find the distance between now and the count down date
        const distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Display the result in the element with id="countdown"
        countdown.innerHTML =
            '<div class="countdown-item"><span class="countdown-number">' + days + '</span>' + '<span class="countdown-text">' + `${days == 1 ? "Tag" : "Tage"}`  + '</span></div>' +
            '<div class="countdown-item"><span class="countdown-number">' + hours + '</span>' + '<span class="countdown-text">' + `${hours == 1 ? "Stunde" : "Stunden"}` + '</span></div>' +
            '<div class="countdown-item"><span class="countdown-number">' + minutes + '</span>' + '<span class="countdown-text">' + `${minutes == 1 ? "Minute" : "Minuten"}` + '</span></div>' +
            '<div class="countdown-item"><span class="countdown-number">' + seconds + '</span>' + '<span class="countdown-text">' + `${seconds == 1 ? "Sekunde" : "Sekunden"}` + '</span></div>';

        // If the count down is finished, write some text
        if (distance < 0) {
            clearInterval(x);
            countdown.innerHTML = "Countdown abgelaufen";
        }
    }, 1000);
}
